import Contract from './Contract.jsx';

export default Contract;
